import { FormattedMessage } from 'react-intl'
import { useNavigate, useSearch } from '@tanstack/react-router'

import { IconRakebackWizardLogoSigned } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { FormContainer } from '@/components/form-container'
import { isDevEnv, isLocalEnv } from '@/config/runtime-env'
import { buildOAuthRedirectUrl, oAuthMigrationUrlFlag } from '@/utils/helpers'

import { RootRoute } from './login'

export const OAuthMigrationRoute = () => {
  const isDev = isDevEnv() || isLocalEnv()
  const urlToReturn = buildOAuthRedirectUrl(oAuthMigrationUrlFlag)
  const search = useSearch({
    from: '/_auth/login/',
  })

  // for dev purposes show old login via email/password
  if (isDev && search.type === 'dev') {
    return <RootRoute />
  }

  return (
    <FormContainer className="mx-auto">
      <div className="flex flex-col gap-8">
        <div className="hidden text-center sm:block">
          <IconRakebackWizardLogoSigned />
        </div>

        <div className="text-center">
          <Typography
            gutterBottom
            variant="h4"
          >
            <FormattedMessage id="auth.oauth.migration.title" />
          </Typography>
          <Typography
            color="text.secondary"
            variant="body1"
          >
            <FormattedMessage id="auth.oauth.migration.description" />
          </Typography>
        </div>

        <Paper
          className="flex flex-col gap-8 rounded-md p-8 sm:p-4"
          elevation="1"
        >
          <div className="text-center">
            <Typography
              gutterBottom
              variant="h4"
            >
              <FormattedMessage id="common.controls.loginWithGto" />
            </Typography>
            <Typography
              color="text.secondary"
              variant="body1"
            >
              <FormattedMessage id="auth.oauth.migration.loginWithGto.description" />
            </Typography>
          </div>

          <Button
            fullWidth
            color="primary"
            component="a"
            href={urlToReturn}
            size="large"
            variant="contained"
          >
            <FormattedMessage id="common.controls.loginWithGto" />
          </Button>

          <Typography
            className="text-center"
            color="text.secondary"
            variant="body1"
          >
            <FormattedMessage id="auth.oauth.migration.loginWithGto.tip" />
          </Typography>
        </Paper>
      </div>
      {isDev && <EmailDevLogin />}
    </FormContainer>
  )
}

const EmailDevLogin = () => {
  const navigate = useNavigate()

  return (
    <Button
      onClick={() => {
        navigate({
          to: '.',
          search: {
            type: 'dev',
          },
        }).catch(console.error)
      }}
    >
      Email Login
    </Button>
  )
}
